import cn from 'classnames';
import { groupBy } from 'lodash';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import {
  getArticleSubTypes,
} from '@/finsight/application/CreditFlowResearch/Articles/ArticlesTile/helpers';
import { useArticlesThemesContext } from '@/finsight/application/CreditFlowResearch/ArticlesMarketThemesContext';

import styles from './typeCell.scss';

const TypeCell = ({
  row,
  className = '',
}) => {
  const {
    themes,
    isInitialized: isThemesInitialized,
  } = useArticlesThemesContext();
  if (!isThemesInitialized) {
    return null;
  }

  const groupedThemesById = groupBy(themes, 'id');
  const types = getArticleSubTypes(groupedThemesById, row.themes);
  if (!types.length) {
    return null;
  }
  const typesString = types.join(', ');
  return (
    <Tooltip content={ typesString }>
      <div className={ cn(styles.cell, className) }>{ typesString }</div>
    </Tooltip>
  );
};

export default TypeCell;
